<div class="form-group">
    <div class="row fields-group">
        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="operator"
                    (ngModelChange)="operatorValueChanged()">
                <option value="" default selected disabled>{{ 'Choose here' | translate }}</option>
				<option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
			</select>
        </div>
        <div class="col-auto" *ngIf="isCatalogMultiple && (catalogGroupFields.length) && !isOperatorIsValid()">
            <label class="input-label">{{ 'dets.subject' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="subject"
                    (ngModelChange)="subjectValueChanged()">
				<option *ngFor="let s of filterSubjects(operator)" [selected]="subject == s">{{ s | translate }}</option>
			</select>
        </div>
        <div class="col" *ngIf="!isOperatorIsValid()">
            <ng-container *ngIf="operator === 'EQUAL' || operator === 'NOT_EQUAL'">
                <label class="input-label">{{ 'catalog.parent_value' | translate }}</label>
                <search-select *ngIf="!isCatalogMultiple && catalogFields"
                        (change)="selectValueChanged($event)"
                        [items]="catalogFields"
                        [prop]="'id'"
                        [selected]="catalogFieldValueId"
                        [placeholder]="'Choose here' | translate"></search-select>
                        <!--
                <select  *ngIf="!isCatalogMultiple && catalogFields && (gdbCatalog && gdbCatalog.gdbCatalogValue?.type !== 'catalog')"
                        class="form-control"
                        [(ngModel)]="catalogFieldValueId"
                        (ngModelChange)="selectValueChanged($event)">
                    <option value="" default selected disabled>{{ 'Choose here' | translate }}</option>
                    <option *ngFor="let c of catalogFields" [ngValue]="c">{{ c }}</option>
                </select>
            -->
                <ng-select *ngIf="isCatalogMultiple && catalogFields" [(ngModel)]="classificationFields"
                        bindLabel="value"
                        bindValue="id"
                        class="custom form-control"
                        [clearable]="true"
                        [multiple]="true"
                        [items]="catalogFields"
                        (change)="updateClassificationFields($event)"
                        placeholder="{{'Select value(s)' | translate }}"></ng-select>
            </ng-container>
            <ng-container *ngIf="catalogGroupFields.length && (operator === 'IN' || operator === 'NOT_IN')">
                <label class="input-label">{{ 'Catalog Group' | translate }}</label>
                <search-select
                        (change)="selectGroupChanged($event)"
                        [items]="catalogGroupFields"
                        [prop]="'id'"
                        [selected]="catalogGroupValue"
                        [placeholder]="'Catalog Group' | translate"></search-select>
            </ng-container>
            <ng-container *ngIf="!isCatalogMultiple">
                <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
                <search-select *ngIf="fields.length > 0"
                        (change)="onTargetFormFieldKeyChange($event)"
                        [items]="fields"
                        [selected]="sourceFormFieldKey"
                        [placeholder]="'Choose here' | translate"></search-select>
            </ng-container>
        </div>
    </div>
</div>
